export default __webpack_public_path__ + "static/media/howItWorks3.2e7e7af1.png";